import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { AuthorizationDTO } from "../models/authorization.model";
import { CompanyListDTO } from "../models/company.model";
import { UserListDTO } from "../models/user.model";

@Injectable({
  providedIn: 'root'
})
export class UserImpersonationsService{

  constructor(private http: HttpClient){

  }

  /**
   * Restituisce le company a cui è stato concessa l'autorizzazione
   */
  getCompaniesByUserGranted(id : string) : Promise<CompanyListDTO[]>{
    return this.http.get<any>(environment.apiFullUrl + '/UsersImpersonation/GetCompaniesByUserGranted/' + id).toPromise();
  }

  /**
   * Restituisce le company che hanno concesso l'autorizzazione
   */
  getCompaniesByUserGranting(id : string) : Promise<CompanyListDTO[]>{
    return this.http.get<any>(environment.apiFullUrl + '/UsersImpersonation/GetCompaniesByUserGranting/' + id).toPromise();
  }

  getUsersGranting(dto : AuthorizationDTO) : Promise<UserListDTO[]>{
    return this.http.post<any>(environment.apiFullUrl + '/UsersImpersonation/GetUsersGranting', dto).toPromise();
  }

  getUsersGranted(dto : AuthorizationDTO) : Promise<UserListDTO[]>{
    return this.http.post<any>(environment.apiFullUrl + '/UsersImpersonation/GetUsersGranted', dto).toPromise();
  }

  addAuthorization(dto : AuthorizationDTO){
    return this.http.post(environment.apiFullUrl + '/UsersImpersonation/AddAuthorization', dto).toPromise();
  }

  removeAuthorization(dto : AuthorizationDTO){
    return this.http.post(environment.apiFullUrl + '/UsersImpersonation/RemoveAuthorization', dto).toPromise();
  }
}
